module.exports = __webpack_public_path__ + "static/media/dna_nutrition-report.ff42236a.png";